import { UseFormReturnType } from '@mantine/form'

export function isFieldDirty<
  T extends Record<string, any>,
>(
  form: UseFormReturnType<T>,
  field: keyof T,
) {
  return form.isDirty(field as string)
}